import moment from "moment"
;["ar", "my"].forEach((x) => {
  // Disable arabic number to symbol mapping 1: ١, 2: ٢, 3: ٣, 4: ٤, 5: ٥, 6: ٦, 7: ٧, 8: ٨, 9: ٩, 0: ٠
  const localeData = moment.localeData(x)
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  localeData.postformat = (y: any) => y
  // @ts-expect-error: Flow to TS migration.
  moment.updateLocale(x, localeData)
})
